document.addEventListener('DOMContentLoaded', function() {
  // Cible tous les blocs de description dans les sections collection
  var selectors = '.font-claude-response-body, .rte';
  
  document.querySelectorAll(selectors).forEach(function(el) {
    if (window.innerWidth >= 750) return;
    
    el.classList.add('is-clamped');
    var btn = document.createElement('button');
    btn.className = 'read-more-btn';
    btn.textContent = 'En savoir plus';
    el.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function() {
      if (el.classList.contains('is-clamped')) {
        el.classList.remove('is-clamped');
        btn.textContent = 'Réduire';
      } else {
        el.classList.add('is-clamped');
        btn.textContent = 'En savoir plus';
      }
    });
  });
});
